import enTranslation from '../lang/en.json';
import indTranslation from '../lang/ind.json';

// Bundle game banners so replacing an image also changes its cache URL.
export default {
    en: {
        name: "en",
        text: "English",
        langJson: {
            ...enTranslation,
            img: {
                ...enTranslation.img,
                index_banner_tawla: require('../assets/images/home/index_banner_tawla.png').default,
                index_banner_btcx: require('../assets/images/home/index_banner_btcx.png').default
            }
        }
    },
    ind: {
        name: "ind",
        text: "Indonesia",
        langJson: {
            ...indTranslation,
            img: {
                ...indTranslation.img,
                index_banner_tawla: require('../assets/images/home/ind_index_banner_tawla.png').default,
                index_banner_btcx: require('../assets/images/home/ind_index_banner_btcx.png').default
            }
        }
    }
};
